import { render, staticRenderFns } from "./postdoctorFund.vue?vue&type=template&id=1e921ab7&scoped=true&"
import script from "./postdoctorFund.vue?vue&type=script&lang=js&"
export * from "./postdoctorFund.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorFund.vue?vue&type=style&index=0&id=1e921ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e921ab7",
  null
  
)

export default component.exports